import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
interface SlideTitleProps {
  onContinue: () => void;
}
export function SlideTitle({
  onContinue
}: SlideTitleProps) {
  return <div className="h-full w-full flex flex-col items-center justify-center px-12 py-16 text-center relative" data-id="element-891">
      <div className="z-10 max-w-4xl w-full space-y-8" data-id="element-892">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="space-y-4" data-id="element-893">
          <p className="text-sm md:text-base text-teal-400 font-semibold uppercase tracking-[0.25em]" data-id="element-894">
            Snakker Investor Deck for GLOBAL HEALTH INVEST
          </p>
          <h1 className="text-5xl md:text-7xl font-serif text-white" data-id="element-895">
            Focus: <br data-id="element-896" />
            <span className="text-teal-400" data-id="element-897">Legacy Brand Optimization</span>
          </h1>
          <p className="text-xl md:text-2xl text-white/70 font-medium max-w-2xl mx-auto mt-6" data-id="element-898">
            Unlocking significant value through continuous, scalable
            optimization.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} className="pt-8" data-id="element-899"></motion.div>
      </div>
    </div>;
}